import { Middleware } from '@reduxjs/toolkit';

import {
  changeConfirmationFieldValue,
  ConfirmationDataItem,
  confirmPayment,
  initiateConfirmation,
  uploadFile,
  uploadFileSuccess,
} from '@cashier/cashier-data-access';
import { InputTypes, PaymentMethodInput } from '@cashier/cashier-model';

export const paymentConfirmationMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === initiateConfirmation.toString()) {
      const {
        paymentConfirmation: { confirmationData, fieldConfigurations },
        paymentProcessing: {
          result: { transactionId },
        },
      } = store.getState();

      const fileField = fieldConfigurations.find(
        (field: PaymentMethodInput) => field.type === InputTypes.FileLink,
      );

      const parameterMap = {};
      Object.values(
        confirmationData as {
          [name: string]: ConfirmationDataItem;
        },
      ).forEach((item) => {
        const { name, value } = item;

        parameterMap[name] = typeof value === 'string' ? value.trim() : value;
      });

      if (fileField && !parameterMap[fileField?.name]) {
        const {
          fileUploading: { data },
        } = store.getState();

        data && store.dispatch(uploadFile(data, transactionId));
      } else {
        store.dispatch(
          confirmPayment({
            transactionId: transactionId,
            paymentAttributes: parameterMap,
          }),
        );
      }
    }

    if (action.type === uploadFileSuccess.toString()) {
      const {
        paymentConfirmation: { fieldConfigurations },
      } = store.getState();

      const fileField = fieldConfigurations.find(
        (field) => field.name === action.payload.name,
      );

      store.dispatch(
        changeConfirmationFieldValue({
          name: fileField?.name,
          value: action.payload.link,
          isValid: true,
        }),
      );

      store.dispatch(initiateConfirmation());
    }

    return result;
  };
